import React from "react";
import { FormElements } from "../../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../../shared/bootstrap/form/input/InputCustom";
import { useLanguageForShared } from "../../../../../../../../shared/utils/languages/useLanguageForShared";

const ConcentratorCoreFixed = ({ dataForm, changeValue, errors, isSubmit, prescriptionTitle = "Fisso" }) => {
  const { t } = useLanguageForShared();

  const formStructurePrescription = [
    {
      name: "fixed.flowRest",
      type: "input",
      label: `${t("prescription.template.flowRest")}*`,
      dataElement: {
        placeholder: t("prescription.template.flowRest_placeholder"),
        type: "text"
      },
      col: { xs: "8", sm: "8", lg: "3", xl: "3" }
    },
    {
      name: "fixed.flowRestHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "4", sm: "4", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    },
    {
      name: "fixed.underStressFlow",
      type: "input",
      label: `${t("prescription.template.underStressFlow")}*`,
      dataElement: {
        placeholder: t("prescription.template.underStressFlow_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "3", xl: "3" }
    },
    {
      name: "fixed.underStressFlowHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    },
    {
      name: "fixed.nightFlow",
      type: "input",
      label: `${t("prescription.template.nightFlow")}*`,
      dataElement: {
        placeholder: t("prescription.template.nightFlow_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "3", xl: "3" }
    },
    {
      name: "fixed.nightFlowHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    }
  ];

  const getValue = (val) => {
    if (!val) return 0;
    const normalized = String(val).replace(",", ".");
    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? 0 : parsed;
  };

  const getFieldValue = (flatKey, nestedKey) => dataForm?.[flatKey] ?? dataForm?.fixed?.[nestedKey];

  const sum =
    getValue(getFieldValue("fixed.nightFlowHourDie", "nightFlowHourDie")) +
    getValue(getFieldValue("fixed.underStressFlowHourDie", "underStressFlowHourDie")) +
    getValue(getFieldValue("fixed.flowRestHourDie", "flowRestHourDie"));

  return (
    <>
      <p className={"title-paragraph"} style={{ fontWeight: "bold", marginBottom: "1.5rem", marginTop: "2rem" }}>{t("sg.prescription")} | {prescriptionTitle}</p>
      <FormElements
        structure={formStructurePrescription}
        dataForm={dataForm}
        changeValue={changeValue}
        isSubmit={isSubmit}
        errors={errors}
      />

      <div className="row">
        <div className="col-sm-12 col-lg-3">
          <FormGroup
            label={{ label: t("prescription.template.check24h.label") }}
            error={{
              isVisible: sum > 24,
              message: t("prescription.template.check24h.error")
            }}
          >
            <InputCustom
              type={"text"}
              name={"fixed.check24h"}
              error={sum > 24}
              value={sum}
              readOnly={true}
              style={{ cursor: "default", fontWeight: "bold" }}
            />
          </FormGroup>
        </div>
      </div>
    </>
  );
};

export default ConcentratorCoreFixed;
